import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { TradeService } from '../../services/TradeService';
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from './customStyles';

const ClientDropdown = ({ selectedAdmin, selectedMaster, selectedBrokerId, selectedSubBrokerId, setSelectedOption, menuPlacement }) => {
  const [clients, setClients] = useState([]);
  const [selectedOption, setSelectedOptionInternal] = useState(null);

  var user = BullCache.getFromCache("user");

  useEffect(() => {
    
    setSelectedOptionInternal(null);
    setSelectedOption(null);

    const fetchClientData = async () => {
      let adminId = user?.adminId; 

     
      if (selectedSubBrokerId) {
        adminId = selectedSubBrokerId.value;
      } else if (selectedBrokerId) {
        adminId = selectedBrokerId; 
      } else if (selectedMaster) {
        adminId =  selectedMaster.value; 
      }else if (selectedAdmin) {
        adminId =  selectedAdmin.value; 
      }

      
      if (adminId) {
        try {
          const res = await TradeService.getUsers({ adminId });
          if (res.code === 1 && res.data.userList.length > 0) {
            setClients(res.data.userList); 
          } else {
            setClients([]);
          }
        } catch (error) {
          console.error('Error fetching client data:', error);
          setClients([]); 
        }
      } else {
        setClients([]); 
      }
    };

    if (selectedAdmin || selectedMaster || selectedBrokerId || selectedSubBrokerId || !selectedAdmin && !selectedMaster && !selectedBrokerId && !selectedSubBrokerId) {
      fetchClientData();
    }

  }, [selectedAdmin, selectedMaster, selectedBrokerId, selectedSubBrokerId]); 

  const clientOptions = clients.map((item) => ({
    value: item.userid,
    label: `${item.firstName} (${item.userName})`,
  }));

  const handleSelectChange = (selected) => {
    const userId = selected?.value;  
    const formattedData = { userId }; 
    setSelectedOption(formattedData); 
    setSelectedOptionInternal(selected);
  };

  return (
    <div>
      <Select
        menuPlacement={menuPlacement}
        options={clientOptions}
        value={selectedOption} 
        onChange={handleSelectChange}
        placeholder="Select"
        isSearchable
        className="text-black fss-01"
        size="sm"
        theme={the}
        styles={customStyles}
        isClearable
      />
    </div>
  );
};

export default ClientDropdown;
